import React from 'react';
import { Link, Navigate, useLocation } from 'react-router-dom';
import { CalendarDays, ChevronLeft, Home, KeyRound, LayoutDashboard, LogOut, Menu, UsersRound } from 'lucide-react';
import { Button } from '../ui/button';
import { FirstPassword } from './FirstPassword';

const entries = [
  ['/responsabile/dashboard', 'Dashboard', LayoutDashboard],
  ['/responsabile/immobili', 'Immobili', Home],
  ['/responsabile/arrivi-partenze', 'Arrivi e partenze', UsersRound],
  ['/responsabile/storico', 'Prenotazioni', CalendarDays],
  ['/responsabile/calendario-sinottico', 'Calendario', CalendarDays],
  ['/responsabile/profilo', 'Password di accesso', KeyRound],
];

export const CollaboratorGate = ({ user, children }) => {
  const { pathname } = useLocation();
  if (user.requires_password_change) return <FirstPassword />;
  if (pathname !== '/responsabile' && !entries.some(([path]) => path === pathname.replace(/\/$/, ''))) return <Navigate to="/responsabile/dashboard" replace />;
  return children;
};

export const CollaboratorNavigation = ({ isOpen, setIsOpen, onLogout, user }) => {
  const { pathname } = useLocation();
  return <>
    {!isOpen && <Button data-testid="hs-operator-menu-open" className="fixed top-4 left-4 z-40" size="icon" aria-label="Apri menu" onClick={() => setIsOpen(true)}><Menu className="h-5 w-5" /></Button>}
    {isOpen && <>
      <button data-testid="hs-operator-menu-backdrop" aria-label="Chiudi menu" className="fixed inset-0 bg-black/30 z-40 md:hidden" onClick={() => setIsOpen(false)} />
      <aside data-testid="hs-operator-sidebar" className="fixed md:sticky top-0 left-0 h-dvh w-64 shrink-0 z-50 bg-white border-r flex flex-col p-5">
        <div className="flex items-center justify-between gap-3 mb-9"><span className="font-bold text-xl text-blue-800">Home Smart</span><Button data-testid="hs-operator-menu-close" size="icon" variant="ghost" aria-label="Chiudi menu" onClick={() => setIsOpen(false)}><ChevronLeft className="h-5 w-5" /></Button></div>
        <p data-testid="hs-operator-name" className="font-medium text-sm break-words">{user.full_name}</p><p className="text-xs text-slate-500 mt-1 mb-7">Responsabile</p>
        <nav className="space-y-1">{entries.map(([path, label, Icon]) => <Link key={path} data-testid={`hs-operator-nav-${path.split('/').pop()}`} to={path} onClick={() => { if (window.innerWidth < 768) setIsOpen(false); }} className={`flex items-center gap-3 p-3 rounded-md text-sm transition-colors ${pathname === path ? 'bg-blue-50 text-blue-800 font-semibold' : 'text-slate-600 hover:bg-slate-50'}`}><Icon className="h-4 w-4" />{label}</Link>)}</nav>
        <Button data-testid="hs-operator-logout" className="mt-auto justify-start" variant="ghost" onClick={onLogout}><LogOut className="mr-2 h-4 w-4" />Esci</Button>
      </aside>
    </>}
  </>;
};